module.exports = __webpack_public_path__ + "static/media/Letra_Caixa (8).4e1b92e3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/fotos/Letra_Caixa/Letra_Caixa (8).jpg
// module id = 347
// module chunks = 0